@for (phase of phases; track phase) {
  <oe-modal-line [name]="phase.name" [textIndent]="TextIndentation.SINGLE">
    <oe-modal-line-item [channelAddress]="component.id + '/Voltage' + phase.key" [roleIsAtLeast]="Role.INSTALLER"
      [converter]="Converter.VOLTAGE_IN_MILLIVOLT_TO_VOLT">
    </oe-modal-line-item>
    <oe-modal-line-item [channelAddress]="component.id + '/Current' + phase.key" [roleIsAtLeast]="Role.INSTALLER"
      [converter]="Converter.CURRENT_IN_MILLIAMPERE_TO_ABSOLUTE_AMPERE">
    </oe-modal-line-item>
    <oe-modal-line-item [channelAddress]="component.id + '/ActivePower' + phase.key"
      [converter]="CONVERT_TO_POSITIVE_WATT">
    </oe-modal-line-item>
  </oe-modal-line>
}
